import calsses from "./MainNotify.module.css";

type Props = {
  title: string;
  close: () => void;
  descr?: string;
};

const MainNotify = ({ title, close, descr }: Props) => {

  const closeBtn = process.env.PUBLIC_URL + '/images/canсel.svg'

  const overlayClickHandler = (event: MouseEvent) => {
    const target = event.target as HTMLTextAreaElement;
    if (target.className === calsses.notify__overlay) close();
  };
  return (
    <div
      className={calsses.notify__overlay}
      onClick={(el) => overlayClickHandler}
    >
      <div
        className={`${calsses.notify__wrapper} animate__animated animate__fadeIn`}
      >
        <div onClick={close} className={calsses.notify__close}>
          <img src={closeBtn} alt="close btn" />
        </div>
        <div className={calsses.notify__title}>{title}</div>

        {descr && <div className={calsses.notify__descr}>{descr}</div>}
      </div>
    </div>
  );
};

export default MainNotify;
